import type { ReactNode } from "react"

import { EYEBROW, H2, LEAD } from "./styles"

export interface SectionHeadingProps {
  eyebrow: string
  title: string
  /** 段落说明，支持 JSX（含插值后的强调文本） */
  lead?: ReactNode
  className?: string
}

/** 区块标题：小标签 + 标题 + 说明 */
export function SectionHeading({
  eyebrow,
  title,
  lead,
  className,
}: SectionHeadingProps) {
  return (
    <div className={`mb-8 max-w-[760px] sm:mb-9 ${className ?? ""}`}>
      <p className={EYEBROW}>{eyebrow}</p>
      <h2 className={H2}>{title}</h2>
      {lead && <p className={`mt-1 ${LEAD}`}>{lead}</p>}
    </div>
  )
}
